module.exports = __webpack_public_path__ + "img/logo_txtwhite_bgtransparent.f8741c06.png";